module.exports = __webpack_public_path__ + "static/media/MountainPeakDestroyedST01EXTA0008_design_clean_v002.01754fc3.png";